import React from 'react'
import Button from '../../common/components/Button'

type Props = {
  onSubmit: Function
}

export default function SerialLookup({onSubmit}: Props) {
  const input = React.useRef<HTMLInputElement>(null);
  const handleSubmit = () => {
    const serial = input.current.value;
    onSubmit(serial);
  }

  return (
    <div className='serial-lookup-modal-content'>
        <h2 className='akey-lookup-h2'>Input Serial</h2>
        <span className='akeytext-small'>Enter serial exactly as it is written</span>
        <div className='form-row'>
            <div className='form-field'>
                <input ref={input} name="serial" placeholder='0000-0000-0000-0000' />
            </div>
        </div>
        <div className='button-group'>
          <Button className='btn-new btn-new-dynamic' style={{marginTop: '8px'}} label="Search" onClick={handleSubmit} />
        </div>
    </div>
  )
}